import { service } from '@/utils/request'

/**
 * [menu 总菜单]
 * @return object [promise对象]
 */
export function menu() {
	return service ({
        // url:'https://easy-mock.com/mock/5a56ccc655fb93147c590965/cloud/push/v1/imservice/cloud/uac/v1/resource/menus2',
		url: '/cloud/uac/v1/admin/resource/menuModel',
		method: 'get'
	})
}


// WEBPACK FOOTER //
// ./src/api/layout/menu.js